import React from 'react';

const QrScanIcon: React.FC = () => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            {/* Corner brackets — top-left */}
            <path d="M4 16C4 9.37 9.37 4 16 4H32" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            <path d="M16 4C9.37 4 4 9.37 4 16V32" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            {/* Corner brackets — top-right */}
            <path d="M88 4H104C110.63 4 116 9.37 116 16" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            <path d="M116 16V32" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            {/* Corner brackets — bottom-left */}
            <path d="M4 88V104C4 110.63 9.37 116 16 116" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            <path d="M16 116H32" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            {/* Corner brackets — bottom-right */}
            <path d="M116 88V104C116 110.63 110.63 116 104 116" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            <path d="M88 116H104" stroke="#30302E" strokeWidth="3" strokeLinecap="round" />
            {/* QR code pattern — top-left block */}
            <rect x="20" y="20" width="28" height="28" rx="4" fill="none" stroke="#30302E" strokeWidth="2.5" />
            <rect x="27" y="27" width="14" height="14" rx="2" fill="#30302E" />
            {/* QR code pattern — top-right block */}
            <rect x="72" y="20" width="28" height="28" rx="4" fill="none" stroke="#30302E" strokeWidth="2.5" />
            <rect x="79" y="27" width="14" height="14" rx="2" fill="#30302E" />
            {/* QR code pattern — bottom-left block */}
            <rect x="20" y="72" width="28" height="28" rx="4" fill="none" stroke="#30302E" strokeWidth="2.5" />
            <rect x="27" y="79" width="14" height="14" rx="2" fill="#30302E" />
            {/* QR code pattern — bottom-right data region */}
            <rect x="72" y="72" width="8" height="8" rx="1.5" fill="#30302E" />
            <rect x="84" y="72" width="8" height="8" rx="1.5" fill="#30302E" />
            <rect x="72" y="84" width="8" height="8" rx="1.5" fill="#30302E" />
            <rect x="84" y="84" width="16" height="8" rx="1.5" fill="#30302E" />
            <rect x="72" y="96" width="16" height="4" rx="1.5" fill="#30302E" />
            <rect x="92" y="96" width="8" height="4" rx="1.5" fill="#30302E" />
            {/* Scan line */}
            <line x1="12" y1="60" x2="108" y2="60" stroke="#0E5BF3" strokeWidth="2" strokeLinecap="round" strokeDasharray="5 4" opacity="0.8" />
        </svg>
    );
};

export default QrScanIcon;
